<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-row :gutter="24">
            <a-col :md="6" :sm="8">
              <a-form-item label="数据库地址">
                <j-input placeholder="请输入数据库地址" v-model.trim="queryParam.databaseAddress"></j-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item label="负责人">
                <j-input placeholder="请输入负责人" v-model.trim="queryParam.responsiblePerson"></j-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item label="数据库名称">
                <j-input placeholder="请输入数据库名称" v-model.trim="queryParam.databaseName"></j-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item label="所属业务">
                <j-input placeholder="请输入所属业务" v-model.trim="queryParam.business"></j-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item label="是否备份">
                <j-dict-select-tag
                  v-model="queryParam.isBackup"
                  placeholder="请选择是否备份"
                  dictCode="backup_or_not"
                ></j-dict-select-tag>
              </a-form-item>
            </a-col>
            <span style="float: right; overflow: hidden" class="table-page-search-submitButtons">
              <a-col :md="6" :sm="24">
                <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                <a @click="handleToggleSearch" style="margin-left: 8px">
                  {{ toggleSearchStatus ? '收起' : '展开' }}
                  <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                </a>
              </a-col>
            </span>
          </a-row>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('数据库清单')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        :scroll="{ x: true }"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{fixed:true,selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="图片不存在" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <busAssetStorageDetail-modal ref="modalForm" @ok="modalFormOk"></busAssetStorageDetail-modal>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import BusAssetStorageDetailModal from './modules/BusAssetStorageDetailModal'
  import JInput from "@comp/jeecg/JInput";


  export default {
    name: "BusAssetStorageDetailList",
    mixins:[JeecgListMixin],
    components: {
      JInput,
      BusAssetStorageDetailModal
    },
    data () {
      return {
        description: '数据库清单管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'数据库地址',
            align:"center",
            dataIndex: 'databaseAddress'
          },
          {
            title:'数据库名称',
            align:"center",
            dataIndex: 'databaseName'
          },
          {
            title:'数据库大小',
            align:"center",
            dataIndex: 'databaseSpaceSize'
          },
          {
            title:'数据库类型和版本',
            align:"center",
            dataIndex: 'databaseType'
          },
          {
            title:'所属业务',
            align:"center",
            dataIndex: 'business'
          },
          {
            title:'业务应用说明',
            align:"center",
            dataIndex: 'applicationDescription'
          },
          {
            title:'负责人',
            align:"center",
            dataIndex: 'responsiblePerson'
          },
          {
            title:'是否备份',
            align:"center",
            dataIndex: 'isBackup_dictText'
          },
          {
            title:'备份策略',
            align:"center",
            dataIndex: 'backupStrategy_dictText'
          },
          {
            title:'备份机制',
            align:"center",
            dataIndex: 'backupMechanism_dictText'
          },
          {
            title:'备份服务器及所在路径',
            align:"center",
            dataIndex: 'backupPath'
          },
          {
            title:'存储介质',
            align:"center",
            dataIndex: 'storageMedium_dictText'
          },
          {
            title:'备份时间点',
            align:"center",
            dataIndex: 'backupTimePoint'
          },
          {
            title:'备份频率',
            align:"center",
            dataIndex: 'backupFrequency'
          },
          {
            title:'备份时长',
            align:"center",
            dataIndex: 'backupTime'
          },
          {
            title:'保留备份天数',
            align:"center",
            dataIndex: 'retentionDays'
          },
          {
            title:'备份文件大小(单个)',
            align:"center",
            dataIndex: 'backupFileSize'
          },
          {
            title:'备注',
            align:"center",
            dataIndex: 'remark'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/assetstorage.base/busAssetStorageDetail/list",
          delete: "/assetstorage.base/busAssetStorageDetail/delete",
          deleteBatch: "/assetstorage.base/busAssetStorageDetail/deleteBatch",
          exportXlsUrl: "/assetstorage.base/busAssetStorageDetail/exportXls",
          importExcelUrl: "assetstorage.base/busAssetStorageDetail/importExcel",
        },
        dictOptions:{},
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      initDictConfig(){
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>